import i18n from '@/plugins/i18n'
import { getPlatformName } from '@/constants/platformNames'
import { OPENSALUD360_LOGO, OPENSALUD360_MX_LOGO } from '@/constants/logosFileNames'
import { OPENSALUD_360_LAYOUT } from '@/constants/layouts'
import { inMx } from '@/helpers/global.helpers'

export default [
  {
    path: '/',
    name: '360',
    component: () => import('@/components/views/360'),
    meta: {
      layout: OPENSALUD_360_LAYOUT,
      title: {
        text () {
          return i18n.t('title-big-1')
        }
      },
      tagLine: getPlatformName(),
      logo: {
        src: inMx ? OPENSALUD360_MX_LOGO : OPENSALUD360_LOGO,
				styleClasses: 'wider'
      },
      i18n: 'public/views/360.json'
    }
  },
  {
    path: 'homeempresas/index',
    redirect: '/'
  }
]



// WEBPACK FOOTER //
// ./src/router/routes/opensalud360.routes.js